export function getContainerStyle() {
    return {
        root: {
            height: "100%",
            width: "100%",
        },
    };
}
export function getGlobalOfflineImageStyle() {
    return {
        root: {
            height: "287px",
            width: "345px",
        },
    };
}
